import http from "./httpService";

const apiEndpoint = "/system";

/**
 * Public reachability probe (no auth). Works on login pages and while logged in.
 */
export function checkNetworkHealth() {
  return http.get(`${apiEndpoint}/ping`, {
    suppressGlobalError: true,
    timeout: 8000,
  });
}
